/*
This file is used to store sensitive info required by JS.
Eventually this should be replaced by environment variables defined in the build system
and not actually deployed.

@todo: move to private/
@see https://docs.wpvip.com/wordpress-skeleton/private-directory/

 */

const MACHINEUSER_KEY = 'STopqqtwUjwgsV4uPVfCyUef';
export { MACHINEUSER_KEY };
